import { render, staticRenderFns } from "./annoymous-query.vue?vue&type=template&id=d20a85e4&scoped=true&"
import script from "./annoymous-query.vue?vue&type=script&lang=js&"
export * from "./annoymous-query.vue?vue&type=script&lang=js&"
import style0 from "./annoymous-query.vue?vue&type=style&index=0&id=d20a85e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d20a85e4",
  null
  
)

export default component.exports